<template>
  <v-card class="pt-3" flat>
    <v-card-title class="headline">Редактирование свойств</v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Название"
              :disabled="$store.getters.user.roleId > 0"
              v-model="object.name"
              :rules="[notEmptyRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="object.dealer"
              :items="choices.dealers"
              label="Дилер"
              no-data-text="Дилер не найден"
              :rules="[notEmptyRule]"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              label="Город"
              v-model="object.city"
              :rules="[notEmptyRule, length50]"
              counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Email"
              v-model="object.email"
              :rules="[notEmptyRule, emailRule, length50]"
              counter="50"
              hint="Для рассылки оповещений"
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              label="Доп. инфо"
              :rows="3"
              v-model="object.description"
              :rules="[notEmptyRule]"
              hint="Контактное лицо, телефон, удаленка и т.п."
              persistent-hint
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              label="Изменил"
              v-model="object.creatorName"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Дата последнего изменения"
              v-model="formatUpdateTime"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary darken-1"
        text
        @click="updateObjectData"
        :disabled="!isValid"
        >Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";

import FormatDateTime from "@/utils/time.js";

export default {
  props: ["objectId"],
  data() {
    return {
      object: {},
      choices: {},
      isValid: true,
      notEmptyRule: (v) => !!v || "Поле не может быть пустым",
      emailRule: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) ||
        "Неверный формат email",
      length100: (v) => (v && v.length <= 100) || "Максимум 100 символов",
      length50: (v) => (v && v.length <= 50) || "Максимум 50 символов",
    };
  },
  computed: {
    formatUpdateTime() {
      if (this.object.updateTime == null) return "";
      return FormatDateTime(this.object.updateTime);
    },
  },
  methods: {
    back() {
      history.back();
    },
    async getDealerChoices() {
      await API.get("dealers/choices")
        .then((response) => {
          console.log(response.data);
          this.choices.dealers = response.data.choices;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getObjectData() {
      await API.get(`objects/${this.objectId}`)
        .then((response) => {
          console.log(response.data);
          this.object = response.data.object;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    updateObjectData() {
      API.post(`objects/${this.objectId}`, this.object)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("showSnackbar", {
            color: "success",
            text: "Свойства Объекта обновлены",
          });
          this.getObjectData();
          this.$store.dispatch("updateObjects");
        })
        .catch((error) => {
          this.$store.dispatch("showSnackbar", {
            color: "error",
            text: "Свойства Объекта не обновлены",
          });
          console.log(error);
        });
    },
  },
  created() {
    this.getDealerChoices().then(() =>
      this.getObjectData().then(() => this.$emit("ready"))
    );
  },
};
</script>

<style>
.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-chip--disabled {
  opacity: 1 !important;
}

input:disabled {
  color: rgba(0, 0, 0, 1) !important;
}
</style>